import { render } from "./DeskReservationView.vue?vue&type=template&id=539ce6d6&scoped=true"
import script from "./DeskReservationView.vue?vue&type=script&lang=js"
export * from "./DeskReservationView.vue?vue&type=script&lang=js"

import "./DeskReservationView.vue?vue&type=style&index=0&id=539ce6d6&lang=css"
import "./DeskReservationView.vue?vue&type=style&index=1&id=539ce6d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539ce6d6"]])

export default __exports__